var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.56 256L205.5 434.2C208.7 437.3 208.8 442.3 205.8 445.5C202.7 448.7 197.7 448.8 194.5 445.8L2.465 261.8C.8902 260.3 0 258.2 0 256C0 253.8 .8902 251.7 2.465 250.2L194.5 66.22C197.7 63.17 202.7 63.27 205.8 66.46C208.8 69.65 208.7 74.72 205.5 77.78L19.56 256zM370.5 77.78C367.3 74.72 367.2 69.66 370.2 66.47C373.3 63.28 378.3 63.17 381.5 66.22L573.5 250.2C575.1 251.7 576 253.8 576 256C576 258.2 575.1 260.3 573.5 261.8L381.5 445.8C378.3 448.8 373.3 448.7 370.2 445.5C367.2 442.3 367.3 437.3 370.5 434.2L556.4 256L370.5 77.78z"
  })));
};

export default SvgCode;